module.exports = __webpack_public_path__ + "static/media/sy.31f8e552.svg";